module.exports = __webpack_public_path__ + "static/img/preview-03.80c19018.webp";